export default __webpack_public_path__ + "static/media/EnvironmentBoxes.820e5dbb.png";